var map = {
	"./2026-05-23-welcome-to-nye-features.md": 11830,
	"./2026-05-25-csv-export.md": 31172,
	"./2026-05-25-forbedret-ordresoegning.md": 58035,
	"./2026-05-25-sharing-expiry-manual-extension.md": 39096,
	"./2026-05-25-spam-filtering.md": 3403,
	"pages/newFeatures/content/2026-05-23-welcome-to-nye-features.md": 11830,
	"pages/newFeatures/content/2026-05-25-csv-export.md": 31172,
	"pages/newFeatures/content/2026-05-25-forbedret-ordresoegning.md": 58035,
	"pages/newFeatures/content/2026-05-25-sharing-expiry-manual-extension.md": 39096,
	"pages/newFeatures/content/2026-05-25-spam-filtering.md": 3403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24412;